export default {
    POLLING_PROCESSES_PENDING: 'POLLING_PROCESSES_PENDING',
    POLLING_NO_PROCESSES_PENDING: 'POLLING_NO_PROCESSES_PENDING',
    PROCESSES_PENDING: 'PROCESSES_PENDING',
    NO_PROCESSES_PENDING: 'NO_PROCESSES_PENDING',
};
